import "./AboutSection.css";
import { useState, useRef } from "react";

export default function AboutSection() {
  const [isSwiping, setIsSwiping] = useState(false);
  const touchStartY = useRef(0);
  const touchMoved = useRef(false);

  const handleLocationClick = () => {
    if (!touchMoved.current) {
      window.open('https://maps.app.goo.gl/tvvDC2ydHNL2ojuYA', '_blank');
    }
  };

  const handleTouchStart = (e) => {
    touchStartY.current = e.touches[0].clientY;
    touchMoved.current = false;
    setIsSwiping(false);
  };

  const handleTouchMove = (e) => {
    const touchCurrentY = e.touches[0].clientY;
    const diff = Math.abs(touchCurrentY - touchStartY.current);
    
    if (diff > 10) {
      touchMoved.current = true;
      setIsSwiping(true);
    }
  };

  const handleTouchEnd = () => {
    setIsSwiping(false);
  };

  return (
    <section id="section2" className="about-section">
      <div 
        className={`about-container ${isSwiping ? 'swiping' : ''}`}
        onClick={handleLocationClick}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            handleLocationClick();
          }
        }}
      >
        <div className="about-bg"></div>
      </div>

      <div className="about-text">
        <h2>ABOUT US</h2>
        <p>
          Το Athens Uncorked είναι μια νέα γιορτή που έρχεται να ταράξει τα νερά της αθηναϊκής σκηνής,
          συνδυάζοντας το κρασί με τη γαστρονομία, τη μουσική και την τέχνη.
          Στις 14 Δεκεμβρίου 2025, το ιστορικό και εμβληματικό PLEX μεταμορφώνεται σε έναν πολυδιάστατο χώρο εμπειριών.
        </p>
        <p>
          Μια ολιστική εμπειρία που φέρνει κοντά την κουλτούρα του κρασιού με τη σύγχρονη αστική δημιουργικότητα.
          Ένας θεσμός που ξεκινά με στόχο να γίνει σημείο αναφοράς, δημιουργίας και απόλαυσης.
        </p>
      </div>
    </section>
  );
}